<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogDetail" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Fiche de Validation d'une demande d'intervention</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card color="" class="mb-5" flat >
                                    <v-layout wrap>
                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations générales sur l'intervention
                                            </v-alert>
                                            <v-card flat>
                                                <v-layout wrap>
                                                    <v-card-text>
                                                        <v-flex xs12>
                                                            <v-flex xs12 class="text-xs-left"> <!--HAUT-->
                                                                <v-layout row>
                                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>Référence</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.IdInterv}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>




                                                                        <v-layout row>
                                                                            <v-flex xs6>Priorité</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.priorite}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                         <v-layout row>
                                                                            <v-flex xs6>Gravité</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.gravite}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                         <v-layout row>
                                                                            <v-flex xs6>Garage</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.garage}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>


                                                                         <v-layout row>
                                                                            <v-flex  xs3 class="mr-3">
                                                                                <a :href="intervDetail.imageDevis" target=_blank>
                                                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="intervDetail.imageDevis" ></v-avatar>
                                                                                </a>
                                                                            </v-flex>
                                                                        </v-layout>

                                                                    </v-flex>



                                                                    <v-flex xs6 class="text-xs-left"> <!--BAS-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>Vehicule</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.vehicule}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                         <v-layout row>
                                                                            <v-flex xs6>Chauffeur du véhicule</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.conducteur}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Type</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.type}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                         <v-layout row>
                                                                            <v-flex xs6>Demandeur</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.demandeur}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                         <v-layout row>
                                                                            <v-flex xs6>Categorie</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.categorie}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row >
                                                                            <v-flex xs6>Budget alloué  </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{new Intl.NumberFormat().format(intervDetail.budgetTotal)}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider row  class="mb-3"></v-divider>

                                                                        <v-layout row >
                                                                            <v-flex xs6>Facture déjà validée  </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{new Intl.NumberFormat().format(intervDetail.mntFactureValide)}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider row class="mb-3"></v-divider>

                                                                        <v-layout row >
                                                                            <v-flex xs6>Ecart budget - facture validée  </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{new Intl.NumberFormat().format(intervDetail.ecartBudget)}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider row class="mb-3"></v-divider>

                                                                        <v-layout class="mb-2" row >
                                                                            <v-flex xs6>Etat budget (si la facture est validée)</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                <el-tag
                                                                                        :type="(intervDetail.ecartBudget >= intervDetail.mntTotOptInterv) ? 'success' : 'danger'"
                                                                                        disable-transitions>
                                                                                    <span v-if="(intervDetail.ecartBudget >= intervDetail.mntTotOptInterv)">Dans le budget</span>
                                                                                    <span v-else>Hors budget</span>
                                                                                </el-tag>

                                                                            </v-flex>
                                                                        </v-layout>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Description</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{intervDetail.motif}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-flex>
                                                    </v-card-text>
                                                </v-layout>
                                            </v-card>
                                        </v-flex>

                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                DIAGNOSTIQUE
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout>
                                                        <v-flex xs6 class="text-xs-left mb-3"> <!--BAS-->
                                                             <v-layout row>
                                                                <v-flex xs6>Maindoeuvre(Fcfa)</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        {{new Intl.NumberFormat().format(intervDetail.maindoeuvre)}}
                                                                    </v-flex>
                                                            </v-layout>
                                                            <v-divider class="mb-3"></v-divider>

                                                            <v-layout row>
                                                                <v-flex xs6>Diagnostique</v-flex>
                                                                <v-flex xs6 class="text-xs-right title">
                                                                    {{intervDetail.libelleDiag}}
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs6 class="text-xs-left ml-3">
                                                            <v-layout row>
                                                                <v-flex xs6>Diagnostique enregistré par</v-flex>
                                                                <v-flex xs6 class="text-xs-right title">
                                                                    {{intervDetail.userDiag}}
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-divider class="mb-3"></v-divider>
                                                             <v-layout row>
                                                                <v-flex xs6>Date d'enregistrement </v-flex>
                                                                <v-flex xs6 class="text-xs-right title">
                                                                    {{intervDetail.dateDiagEnreg}}
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout wrap>
                                                        <v-flex xs12>
                                                            <v-card class="pt-2">
                                                                 <h4>LISTE DES ARTICLES FOURNIS PAR LE GARAGE: {{intervDetail.garage}}</h4>
                                                                 <v-flex xs12   >
                                                                    <v-chip style="font-size:20px" label outline color="green"><b>Total (TTC): {{new Intl.NumberFormat().format(intervDetail.mntTotOptInterv)}} fcfa</b></v-chip>
                                                                </v-flex>
                                                                <v-layout row>
                                                                    <el-table :data="intervDetail.optionInterv" style="width: 100%">
                                                                        <el-table-column prop="libProd" label="Designation" sortable> </el-table-column>
                                                                        <el-table-column prop="qte" label="Quantite"> </el-table-column>

                                                                        <el-table-column  prop="prix" label="Prix unitaire"></el-table-column>
                                                                        <el-table-column  prop="mntTotal" label="Total"></el-table-column>
                                                                    </el-table>
                                                                </v-layout>
                                                                <br>
                                                            </v-card>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-card-text>
                                            </v-card>
                                        </v-flex>

                                          <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                PRODUITS EN STOCKS
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>
                                                        <v-flex xs12 class="text-xs-left mb-3"> <!--BAS-->
                                                             <v-layout row>
                                                                  <v-flex xs12 class="m3-2 ml-1 mr-1 mb-3">
                                                                        <el-alert
                                                                            title="Produit stock"
                                                                            :description="'Après la validation un bon de sortie sera disponible dans l\'entrepot concerné si le produit est en nombre suffisant. Une commande sera générée dans le cas contraire'"
                                                                            :closable="false"
                                                                            show-icon
                                                                            type="warning">
                                                                        </el-alert>
                                                                    </v-flex>
                                                             </v-layout>
                                                             <v-layout row>
                                                                <v-flex xs2>Entrepot concerné</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        {{intervDetail.entrepot}}
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout wrap>
                                                        <v-flex xs12>
                                                            <v-card class="pt-2">
                                                                <v-card-text>
                                                                    <v-layout row>
                                                                    <el-table :data="intervDetail.optionIntervStock" style="width: 100%">
                                                                        <el-table-column prop="libProd" label="Designation" sortable> </el-table-column>
                                                                        <el-table-column prop="qte" label="Quantite"> </el-table-column>
                                                                        <el-table-column  prop="qteStock" label="Quantite en stock"></el-table-column>

                                                                    </el-table>
                                                                </v-layout>
                                                                </v-card-text>
                                                                <br>
                                                            </v-card>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
            <v-tooltip top>
                    <v-btn  class="mb-5" style="margin-right: 100px"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="red"
                           @click="dialogConfirmRefus = true"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                    <span>Refuser la demande</span>
                </v-tooltip>



                <v-tooltip top>
                    <v-btn class="mb-5 ml-5"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="green"
                           @click="dialogConfirm = true"
                    >
                        <v-icon>done</v-icon>
                    </v-btn>
                    <span>Valider la demande</span>
                </v-tooltip>
        </v-dialog>

         <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation de facture</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous Refuser cette facture ?"
                        :closable="false"
                        show-icon
                        type="error">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">FACTURE </p>
                    <p class="black--text .font-weight-regular subheading" >{{intervDetail.Idfact}}</p>
                </v-flex>
                <v-flex xs12>
                    <el-form  id="formRefus" :rules="ruleFormRefus" ref="refFormRefust"  label-position="top" :inline="true" :model="formRefus" class="demo-form-inline">
                     <v-flex xs12 >
                        <el-form-item style="width:100%" label="Commentaire" prop="rapportRefus" >
                            <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Pourquoi voulez-vous refuser ?" v-model="formRefus.rapport"></el-input>
                        </el-form-item >
                    </v-flex>
                    </el-form>
                </v-flex>

            </v-layout>

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirmRefus = false">Annuler</v-btn>
                <v-btn color="red darken-1" dark @click.native="SubmitRefusDevis()">Refuser</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>

         <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation de la demande d'intervention</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous valider la demande d'intervention ?"
                        :closable="false"
                        show-icon
                        type="success">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">DEMANDE D'INTERVENTION </p>
                    <p class="black--text .font-weight-regular subheading" >{{intervDetail.IdInterv}}</p>
                    <p class="red--text .font-weight-regular subheading" >MONTANT: {{new Intl.NumberFormat().format(intervDetail.mntTotCom)}} FCFA</p>
                </v-flex>
            </v-layout>

                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirm = false">Annuler</v-btn>
                <v-btn color="green darken-1" dark  @click.native="SubmitValideDevis()">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "ModalValidationFacture",
        props:["show","intervDetail","totalFact"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit:[],
            totalTTC:0,
            formRapport:{},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            commandeDeriv:[],
            dialogConfirm: false,
            formRefus:{},
             ruleFormRefus: {
                rapportRefus: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            }
         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDetail = newValue
               if(newValue == true){
                   this.analyseCommande(this.intervDetail.commandes[0].idCommande);
               }
            }
        },

        methods: {
             successNotif(mess = ""){
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
            },
             closeDialog(){
                this.$emit('close',this.intervDetail.intervId,"intervention")
            },
             loadDevisConstat ()
            {
            this.loading = true
            let url = this.domaine + 'demande_maintenance/devis/constat/'+this.intervDetail.idDemande
            this.$http.get(url).then(response => {

                this.tableProduit = response.body.tableProduit
                this.formRapport.rapport = response.body.rapport
                this.totalTTC = response.body.total
                 this.loading = false
            },errResp=>{
                 this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la table des produits")
            })
            },
            handleSuccess(response, file, fileList){
                    this.fileList.push(file)
            },
            handlePictureCardPreview(file, fileList) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            imprimerDetail(){


                let  url = this.domaine+"demande_maintenance/imprimerPDF/demande/"+this.user.id+"/"+this.intervDetail.idDemande
                window.open(url)
            },


             SubmitValideDevis()
             {
                this.loading = true
                var data = new FormData()
                data.append('idUser', this.user.id)
                data.append('etape', 3)
                data.append('reponse', 3)
                data.append('remarque', "")
                data.append('intervId', this.intervDetail.intervId)
                data.append('entrepotId', this.intervDetail.entrepotId)
                let url = this.domaine + 'intervention/new/valider/intervention'
                this.$http.post(url, data).then(response =>
                    {
                        this.loading = false
                        this.$notify({
                            title: 'ENREGISTREMENT REUSSI',
                            message: "Validation de l'intervention enregistré avec succès.",
                            type: 'success',
                            position: 'top-center'
                        });
                        this.dialogConfirm = false
                        this.closeDialog();
                        return response.body.message

                    }).then(message =>
                    {                        
                        for(mes in message) {
                            this.$notify({
                            title: 'COMMANDE GENEREE ',
                            message: mes,
                            type: 'success',
                            position: 'top-center'
                        });
                        }

                    }, response =>
                    {                        
                        this.loading = false
                        this.dialogConfirm = false
                        this.closeDialog();
                    })
            },


             SubmitRefusDevis(){
                this.loading = true
                let url = this.domaine + 'intervention/new/'+ this.intervDetail.intervId +'/valider/intervention'

                let data = new FormData()
                data.append("id",  this.intervDetail.idFact)
                data.append("idUser",  this.user.id)
                data.append('etape', 2)
                data.append("remarque", this.formRefus.rapport)
                data.append("reponse", 2)
                this.$http.post(url,data).then(response => {
                this.loading = false
                this.successNotif(response.body.message)
                this.dialogConfirmRefus = false
                this.closeDialog();
            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors de la facture")
            })
            },

            analyseCommande(idCommande){
                   //analyse des produit des la commande
                   let url = this.domaine + 'comparateur/commande/'+idCommande;
                   this.$http.get(url).then(response => {
                        const respFour = response.body.fournisseurs[0];
                        let listeFoun = [];
                      for(let four in respFour ){
                        //nbCmd++;
                        let listeProduit = respFour[four]
                        let infoFour = {
                          "fournisseur": four,
                          "produits": [],
                          "mntTotal": 0
                        }
                        for(let produit of listeProduit){
                          infoFour.produits.push(produit)
                          infoFour.mntTotal += parseFloat(produit.mntTotal);
                        }
                        listeFoun.push(infoFour)
                      }
                       this.commandeDeriv = listeFoun;
                   }, errorResp =>{

                   });
            }


        },
        mounted(){

        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationInterv.vue